import useEnumValues from 'app/hooks/useEnumValues'
import {
    RequiredContainersCustomer,
} from 'app/types/common.types'
import {
    RequiredContainersInternal,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import {
    useAppSelector,
} from 'app/store/hooks'
import {
    selectConfigByFieldName,
} from 'app/store/Configs'

import List from '../List'

type Props = {
    value?: (RequiredContainersInternal | RequiredContainersCustomer)[],
    configName: string,
    mapCellProps: string,
    allowedValuesEnum?: Record<string, string>,
}

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

const RequiredContainersList = ({
    value = EMPTY_ARRAY,
    configName,
    mapCellProps,
    allowedValuesEnum = EMPTY_OBJECT,
}: Readonly<Props>) => {
    const fieldConfig = useAppSelector((state) => {
        return selectConfigByFieldName(state, configName, mapCellProps)
    })

    const allowedValues = useEnumValues()(fieldConfig?.allowedValuesEnum || allowedValuesEnum || {})

    const labels = value.map((item: RequiredContainersCustomer | RequiredContainersInternal) => {
        const label = allowedValues[(item as RequiredContainersCustomer).productType]
            || (item as RequiredContainersInternal).containerType?.containerModel
        const {
            quantity,
        } = item

        return `${quantity} x ${label}`
    })

    if (!value.length) {
        return null
    }

    return (
        <List value={labels} />
    )
}

export default RequiredContainersList
